<template>
  <p class="product-attribute text-sm">
    {{ label }}:
    <span :itemprop="hasSchema ? SCHEMA_ITEM_PROP.SKU : undefined">
      {{ value }}
    </span>
  </p>
</template>

<script lang="ts">

import { SCHEMA_ITEM_PROP } from '~~/constants/seo';

export default defineComponent({
  name: 'ProductAttribute',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    hasSchema: {
      type: Boolean,
      default: false,
    },
  },
  setup() {

    return { SCHEMA_ITEM_PROP };
  
  },
});

</script>
